import React from "react";
import { useTranslation } from "react-i18next";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Typography from "@mui/material/Typography";
import NotesRow from "./NoteRow";
import ColourConstants from "helpers/colourConstants";
import TableStyle from "styles/application/TableStyle";

const AT = TableStyle();

const useStyles = makeStyles()((theme) => ({
	responsiveTable: {
		minWidth: "99%",
	},
	tableHead: {
		backgroundColor: "#D2D2D9",
	},
	headerText: {
		fontSize: 21,
		marginTop: 10,
	},
	tableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackground,
		fontWeight: "bold",
		borderRightColor: "#979797",
		borderRightStyle: "solid",
		borderRightWidth: "1px",
	},
}));

const Notes = ({ data, isPrint }) => {
	const { classes, cx } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			<Typography className={classes.headerText} component="h1" gutterBottom>
				<strong>{t("label.notes")}</strong>
			</Typography>
			<AT.TableContainer className={classes.responsiveTable}>
				<Table>
					<TableHead className={classes.tableHead}>
						<TableRow className={classes.tableHeadRow}>
							<TableCell
								className={classes.tableHeadRow}
								style={{ width: "300px" }}
							>
								{t("label.name")}
							</TableCell>
							<TableCell
								className={classes.tableHeadRow}
								style={{ width: "300px" }}
							>
								{t("label.date")}
							</TableCell>
							<TableCell className={classes.tableHeadRow}>{t("label.note")}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.length > 0 ? (
							data.map((row) => (
								<NotesRow
									key={row.id}
									row={row}
									classes={classes}
									isPrint={isPrint}
								/>
							))
						) : (
							<TableRow>
								<TableCell>{t("message.noRecordsFound")}</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</AT.TableContainer>
		</div>
	);
};

export default Notes;
